import $ from 'jquery';
import MicroModal from 'micromodal';
import { api } from '../utils/api.js';
import { notifier } from '../utils/notifier.js';

export async function generateFreeCheatForm(dataProvider = getFreeCheatData) {
	const $container = $('[data-free-cheat-form]');
	const $freeChatSelectFirst = $container.find('[data-free-cheat-first]').empty();
	const $freeCheatSelects = $container.find('[data-free-cheat-selects]').empty();
	const $freeCheatServices = $container.find('[data-free-cheat-services]').empty();

	const data = dataProvider();
	Object.values(data).forEach((item, index) => {
		const social = item.title;
		const service = item.service;
		const isFirst = index === 0;

		$freeCheatSelects.append(createFreeCheatSelect(social, isFirst));
		$freeCheatServices.append(createFreeCheatService(social, service, isFirst));
		if (isFirst) $freeChatSelectFirst.text(social);
	});

	initializeTimer();
}

function createFreeCheatSelect(social, active) {
	return $(`
    <li class="select__option" data-select-option="${social}">
      <button type="button" class="select__button btn-res flex-align-center state-color ${active ? 'is-active' : ''}" data-option-inner-button="${social}">
        <span class="select__value">${social}</span>
      </button>
    </li>
  `);
}

function createFreeCheatService(social, service, active) {
	return $(`
    <div class="form__block form__select-target flex-column ${active ? 'is-visible' : ''}" data-service-id="${service?.SERVICE_ID}" data-select-target="${social}">
      <label class="form__label flex">
        <span class="form__label-txt">Накрутить ${service?.WITH_BUDGET} бесплатных подписчиков в ${social}</span>
      </label>
      <input class="input" type="text" data-service-url placeholder="${service?.URL_PLACEHOLDER}">
    </div>
  `);
}

async function initializeTimer() {
	const $form = $('[data-free-cheat-form]');
	const $minutesVal = $form.find('[data-minutes-val]');
	const $secondsVal = $form.find('[data-seconds-val]');
	const $freeCheatDescr = $form.find('[free-cheat-descr]');

	let visit = await api.get('/api/remainingVisit');
	$freeCheatDescr.html(visit.message);

	let timerInterval = null;
	let timeLeft = parseInt(visit.remaning);
	updateTimerDisplay(timeLeft);

	if (timeLeft <= 0 || visit.used) {
		endTimer();
		return;
	}

	timerInterval = setInterval(() => {
		timeLeft--;
		if (timeLeft <= 0) {
			endTimer();
		} else {
			updateTimerDisplay(timeLeft);
		}
	}, 1000);

	async function endTimer() {
		if (timerInterval) {
			clearInterval(timerInterval);
			updateTimerDisplay(0);
		}

		let response = await api.get('/api/approveVisit');
		$freeCheatDescr.html(response.message);

		if (response.canCreate) {
			$('[data-free-cheat-selector]').addClass('form-locked-hide');
		} else {
			$('[data-free-cheat-selector]').removeClass('form-locked-hide');
		}
	}

	function updateTimerDisplay(seconds) {
		const minutes = Math.floor((seconds % 3600) / 60);
		const secs = seconds % 60;
		$minutesVal.text(minutes.toString().padStart(2, '0'));
		$secondsVal.text(secs.toString().padStart(2, '0'));
	}
}

export function initFreeCheatForm() {
	$(document).on('click', '.select__button[data-option-inner-button]', function () {
		const $this = $(this);
		const social = $this.data('option-inner-button');
		const $form = $this.closest('.free-cheat__form');
		$form.find('.form__select-target').removeClass('is-visible');
		$form.find(`.form__select-target[data-select-target="${social}"]`).addClass('is-visible');
		$form.find('.select__title .select__value').text($this.find('.select__value').text());
	});

	$('.free-cheat__form').on('submit', async function (e) {
		e.preventDefault();
		const $form = $(this);
		const serviceId = $form.find('[data-free-cheat-services] [data-service-id].is-visible').data('service-id');
		const $activeInputBlock = $form.find('.form__select-target.is-visible');
		const url = $activeInputBlock.find('input').val();

		if (!url.trim()) {
			notifier.alert('Введите ссылку на профиль');
			return;
		}

		if (!serviceId) {
			notifier.alert('Выберите социальную сеть');
			return;
		}

		try {
			const response = await api.post('/api/createOrder', {
				serviceId,
				link: url,
				isFreePromo: true,
			});

			if (response.result) {
				MicroModal.show('modal-free');
				await generateFreeCheatForm();
			}
		} catch (error) {
			console.error('Axios error:', error.response?.status, error.response?.data);
			notifier.alert('Ошибка сервера. Попробуйте позже.');
		}
	});
}

export function getFreeCheatData() {
	return Object.entries(window.application.data).reduce((acc, [title, services]) => {
		const subscriberServices = Array.isArray(services['Подписчики'])
			? services['Подписчики']
			: [];
		const service = subscriberServices.find((item) => (
			Number(item?.SERVICE_ID) > 0
			&& Number(item?.FINAL_RATE) > 0
			&& Number(item?.WITH_BUDGET) > 0
		));

		if (service) {
			acc.push({ title, service });
		}
		return acc;
	}, []);
}
